import { PREDICTIONS_SUB_PAGES_IDS } from './const';

export const getSelectedTabId = (
  pathname: string,
  forecastingPages: {
    id: PREDICTIONS_SUB_PAGES_IDS;
    route: string;
    linkComponent: string;
  }[]
) => {
  const selectedTabId = forecastingPages.find(page => pathname.indexOf(page.route) !== -1);
  return selectedTabId?.route;
};
